import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import { SettingsSidebar } from '@/components/molecules/SettingsSidebar';
import { CloseCircle } from 'iconsax-react';










export default function Settings() {
  const [isSettingsOpen, setIsSettingsOpen] = useState(true);
  const navigate = useNavigate();

  const handleClose = () => {
    setIsSettingsOpen(false);
    navigate('/dashboard');
  };

  return (
    <>
      {isSettingsOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-[#191919] w-full max-w-7xl h-[90vh] rounded-lg shadow-2xl flex overflow-hidden">
            <SettingsSidebar />
            <div className="flex-1 flex relative">
              <div className="flex-1">
                <div className="p-6">
                  <main>
                    <Outlet />
                  </main>
                </div>
              </div>
              <div className="absolute top-4 right-4 cursor-pointer hover:bg-dark-20 rounded-full p-1">
                <CloseCircle
                  size={24}
                  color="#FFFFFF"
                  onClick={handleClose}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}






